import {Props} from './model';
import {View} from 'react-native';
import * as React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {Breadcrumbs} from '../../../../shared/components/breadcrumbs';
import {ResponsiveView} from '../../../../shared/components/responsiveView';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {PollsCards} from '../pollsCards';
import {Button} from '../../../../shared/components/button';
import {Text} from '../../../../shared/components/text';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {PollsTable} from '../pollsTable';

export default ({breadcrumbs, title, description, pollGroups, isLoading}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    sectionContainer: {
      marginTop: 32,
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 24}, {paddingHorizontal: 16}),
      paddingBottom: theme.screen.bottomOffset,
    },
    sectionContent: {},
    sectionTitle: {
      ...theme.fonts.h2,
      marginBottom: 40,
      marginTop: 40,
    },
    description: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h5Light,
          marginBottom: 42,
        },
        {
          ...theme.fonts.bodySmallLight,
          marginBottom: 35,
        },
      ),
    },
    groupContainer: mediaOnly(DeviceSize.desktop, {marginTop: 64}, {marginTop: 55}),
    groupContainerFirst: {
      marginTop: 0,
    },
    groupTitle: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          ...theme.fonts.h3,
          marginBottom: 20,
        },
        {
          ...theme.fonts.h6,
          marginBottom: 28,
          textAlign: 'center',
        },
      ),
    },
    groupLoadMoreWrapper: {
      alignItems: 'center',
      marginTop: 30,
    },
    groupLoadMoreButton: {
      ...mediaOnly(DeviceSize.mobile, {width: '100%'}, {width: 328}),
    },
    noItemsText: mediaOnly(
      DeviceSize.desktop,
      {},
      {
        textAlign: 'center',
      },
    ),
  }));
  return (
    <View style={styles.sectionContainer}>
      <Breadcrumbs routes={breadcrumbs} />
      <View style={styles.sectionContent}>
        <ResponsiveView only={[DeviceSize.desktop]}>
          <Text testID='polls-type-title-id' style={styles.sectionTitle}>
            {title}
          </Text>
        </ResponsiveView>
        {description ? (
          <Text testID='polls-description-id' style={styles.description}>
            {description}
          </Text>
        ) : null}
        <LoadableContent loading={isLoading}>
          {pollGroups.map(({polls, title: groupTitle, showLoadMore, onLoadMore, noItemsText}, i) => (
            <View style={[styles.groupContainer, i === 0 ? styles.groupContainerFirst : null]} key={i}>
              <Text testID={`polls-group-${i}-title-id`} style={styles.groupTitle}>
                {groupTitle}
              </Text>
              {polls?.length === 0 ? (
                <Text testID={`polls-type-empty-${i}-id`} style={styles.noItemsText}>
                  {noItemsText}
                </Text>
              ) : null}
              {polls?.length !== 0 ? (
                <View>
                  <ResponsiveView only={[DeviceSize.desktop]}>
                    <PollsTable polls={polls} />
                  </ResponsiveView>
                  <ResponsiveView exclude={[DeviceSize.desktop]}>
                    <PollsCards polls={polls} />
                  </ResponsiveView>
                  {showLoadMore ? (
                    <View style={styles.groupLoadMoreWrapper}>
                      <Button
                        id={`polls-${polls?.[0]?.typeId}-more`}
                        style={styles.groupLoadMoreButton}
                        onPress={onLoadMore}
                        text='Показать еще'
                        type='secondary'
                      />
                    </View>
                  ) : null}
                </View>
              ) : null}
            </View>
          ))}
        </LoadableContent>
      </View>
    </View>
  );
};
